import { Component } from '@angular/core';

@Component({
  template: `
    <h1>Dashboard is coming soon....</h1>
  `
})
export class PageNotFoundComponent {}
